<template>
  <small class="warning-text">
    This child is too old for this location.
  </small>
</template>

<style lang="scss" scoped>
.warning-text {
  color: red;
}
</style>
